import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PolicyPage.css';

const PolicyLayout = ({ title, updated, children }) => {
  const navigate = useNavigate();

  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="policy-hero-inner">
          <button className="policy-back-link" onClick={() => navigate('/')}>
            &larr; Back to Intranet
          </button>
          <h1>{title}</h1>
          {updated && <p className="policy-updated">Last updated: {updated}</p>}
        </div>
      </div>

      <div className="policy-shell">
        <div className="policy-content">{children}</div>
      </div>
    </div>
  );
};

export default PolicyLayout;